import * as React from 'react';

import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { UitkQueuedImage } from 'uitk-react-images';

import { FavoriteButton } from 'components/common/shortlist/favorite-button';
import { RenderImageProps } from './title';

interface TitleImageProps {
  src?: string;

  renderImg?: RenderImageProps;
  serverRender: boolean;
  loaded?: boolean;
}

export const serverRenderImageFallbackcb = (fallback?: string, style?: any) => {
  const hasBackgroundSrc = style && style.backgroundImage;
  const fallbackStyle = `url(${fallback})`;

  if (!hasBackgroundSrc && fallback) {
    return { backgroundImage: fallbackStyle };
  } else if (hasBackgroundSrc && fallback && style.backgroundImage !== fallbackStyle) {
    return { backgroundImage: `${style.backgroundImage}, ${fallbackStyle}` };
  }

  return style;
};

export const TitleImage: React.FunctionComponent<TitleImageProps> = ({ src, renderImg, serverRender, loaded }) => {
  const meta = renderImg?.shortlistModel && renderImg?.shortlistModel.meta;
  const hotelId = meta && meta.hotelId;

  const imageSrc = typeof src === 'undefined' ? '' : src || renderImg?.fallbackImageSrc;
  const queuedImageFallbackCallback = imageSrc
    ? (queuedImage: Record<string, unknown>) => renderImg?.queuedImageFallbackcb(renderImg?.fallbackImageSrc, queuedImage)
    : undefined;
  const serverRenderImageFallbackStylecb = imageSrc
    ? (style: Record<string, unknown>) => serverRenderImageFallbackcb(renderImg?.fallbackImageSrc, style)
    : undefined;

  return (
    <UitkQueuedImage
      src={imageSrc}
      alt={name}
      className={`image-loader${serverRender ? '' : ' image-loader--lazy'}`}
      useBackgroundImage={true}
      groupId="HSR"
      queuedImageFallbackCallback={queuedImageFallbackCallback}
      ratio={renderImg?.ratio}
      serverRenderCallback={serverRenderImageFallbackStylecb}
      serverRender={serverRender}
      loaded={loaded}
    >
      {hotelId && (
        <UitkLayoutPosition type="absolute" position={{ top: 'zero', right: 'zero', zindex: 'layer3' }}>
          <FavoriteButton
            shortlistModel={renderImg?.shortlistModel}
            label={renderImg?.favButtonText?.labelSave}
            onSaveMessage={renderImg?.favButtonText?.onSaveMessage}
          />
        </UitkLayoutPosition>
      )}
    </UitkQueuedImage>
  );
};
TitleImage.displayName = 'TitleImage';
